import React, { Component } from 'react';
import { ChromePicker } from 'react-color'
import $ from 'jquery';
import Select from 'react-select';
import Slider from 'rc-slider';
import uuid from 'uuid';
import _ from 'underscore';

import { createMedia, fetchMedia } from '../actions/actions_media';
import { changeMapData, changeMapCategories } from '../actions/index';


if (!HTMLCanvasElement.prototype.toBlob) {
  Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
    value: function (callback, type, quality) {
      var canvas = this;
      setTimeout(function() {

    var binStr = atob( canvas.toDataURL(type, quality).split(',')[1] ),
        len = binStr.length,
        arr = new Uint8Array(len);

    for (var i = 0; i < len; i++ ) {
      arr[i] = binStr.charCodeAt(i);
    }

    callback( new Blob( [arr], {type: type || 'image/png'} ) );

      });
    }
  });
}

class CustomIconCreator extends Component {

  constructor(props) {
    super(props);
    this.selectValue = this.selectValue.bind(this)
    this.state = {
      currentEditorTab: 'defaults',
      displayIconColorPicker : false,
      iconSize : 100,
      currentImage : false,
      mediaPage : 1,
      colourChanged : false,
      iconAnchor : 'bottom',
      currentColor : '',
      icons : {
        defaults : [], maki : [], mapkey: []
      }
    }
  }

  componentDidMount() {
    // Calls to get icon text file lists
    let textFiles = ['defaults','maki','mapkey'];
    var that = this;
    textFiles.forEach(function(textFile) {
      fetch($('#wp_mapbox_gl_js_plugin_url').val()+'/wp-mapbox-gl-js/admin/wp-mapmaker/public/img/'+textFile+'/'+textFile+'-icons.txt',{
        method: 'GET'
      })
      .then(response => response.text())
      .then(text => {
        var newState = JSON.parse(JSON.stringify(that.state));
        var imageArray = text.split("\n");
        newState['icons'][textFile] = imageArray;
        that.setState(newState);
      })
      .catch(error => console.log(error.message));
    })
    if(this.props.media)
    this.props.dispatch(fetchMedia(this.state.mediaPage));

    if(this.props.currentGeometry.properties.marker_icon_url.indexOf('img/black_default.png')>-1) {
      this.setState({
        currentEditorTab: 'defaults',
        currentImage : this.props.currentGeometry.properties.marker_icon_url
      }, () => {
        this.selectImage('black_default.png');
      });
    } else {
      if(this.props.currentGeometry.properties.marker_icon_url.indexOf('/wp-mapbox-gl-js/admin/wp-mapmaker/public/img/')>-1) {
        var imageSplit = this.props.currentGeometry.properties.marker_icon_url.split('/wp-mapbox-gl-js/admin/wp-mapmaker/public/img/')[1];
        var tabColorAndName = imageSplit.split('/');
        var imageColor = '';
        var imageName = tabColorAndName[1].split('-wp_mapbox_gl_js_sizing')[0];
        if(tabColorAndName.length===3) {
          imageColor = tabColorAndName[1];
          imageName = imageColor+'/'+tabColorAndName[2].split('-wp_mapbox_gl_js_sizing')[0];
        }
        this.setState({
          currentEditorTab:tabColorAndName[0],
          currentImage : this.props.currentGeometry.properties.marker_icon_url,
          currentColor : imageColor
        }, () => {
            this.selectImage(imageName);
        });
      } else {
        var imageURL = this.props.currentGeometry.properties.marker_icon_url.split('-wp_mapbox_gl_js_sizing')[0];
        this.setState({
          currentEditorTab: 'uploaded',
          currentImage : this.props.currentGeometry.properties.marker_icon_url
        }, () => {
            this.selectImage(imageURL);
        });
      }
    }
  }

  // componentWillReceiveProps(nextProps) {
  // }

  fetchMoreMedia() {
    this.props.dispatch(fetchMedia(this.state.mediaPage+1));
    this.setState({mediaPage:this.state.mediaPage+1});
  }

  selectValue(e) {
    if(e.value!=='custom-creator') {
      this.props.setMapObject('markerIcon',[e.value,'bottom'])
    } else {
      this.toggleCustomCreator();
    }
  }

  selectImage(image) {
    var canvas = document.getElementById('wp_mapbox_gl_js_canvas');
    var ctx = canvas.getContext('2d');
    var img  = document.getElementById('wp_mapbox_gl_js_canvas_img');
    img.width = 100;
    img.height = 100;
    this.setState({iconSize:100})
    img.onload = function() {
      canvas.width  = img.width;
      canvas.height = img.height;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, img.width, img.height);
    };
    if(this.props.currentGeometry.properties.marker_icon_url.indexOf('/wp-mapbox-gl-js/admin/wp-mapmaker/public/img/')>-1) {
      img.src = $('#wp_mapbox_gl_js_plugin_url').val()+'/wp-mapbox-gl-js/admin/wp-mapmaker/public/img/'+this.state.currentEditorTab+'/'+image;
      this.setState({currentImage:$('#wp_mapbox_gl_js_plugin_url').val()+'/wp-mapbox-gl-js/admin/wp-mapmaker/public/img/'+this.state.currentEditorTab+'/'+image, iconSize:100})
    } else {
      img.src = image;
      this.setState({currentImage:image, iconSize:100})
    }
  }

  selectUploadedImage(image) {
    var canvas = document.getElementById('wp_mapbox_gl_js_canvas');
    var ctx = canvas.getContext('2d');
    var img  = document.getElementById('wp_mapbox_gl_js_canvas_img');
    img.width = 100;
    img.height = 100;
    img.onload = function() {
      canvas.width  = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0, img.width, img.height);
    };
    img.src = image.source_url;
    this.setState({colourChanged:false, currentImage:image.source_url, iconSize:100})
  }

  adjustIconSize(range) {
    var img  = document.getElementById('wp_mapbox_gl_js_canvas_img');
    img.width = range;
    img.height = range;
    this.setState({iconSize:range})
  }

  setIcon(e,imageURL) {
    e.preventDefault();
    var img = document.getElementById('wp_mapbox_gl_js_canvas_img');
    this.props.setMapObject('markerIcon',[img.src+'-wp_mapbox_gl_js_sizing-'+img.width+'-'+img.width,this.state.iconAnchor])
    this.props.closeIconCreator();
  }

  fileUpload(e) {
    // Uses WP REST API
		var formData = new FormData();
		formData.append( 'file', e.target.files[0] );
    this.props.dispatch(createMedia(formData,'uploaded'));
  }

  changeColour(e) {
    e.preventDefault();

    var canvas = document.getElementById('wp_mapbox_gl_js_canvas');
    var ctx = canvas.getContext('2d');
    var img  = document.getElementById('wp_mapbox_gl_js_canvas_img');
    img.width = 100;
    img.height = 100;
    this.setState({iconSize:100})
    img.onload = function() {
      canvas.width  = img.width;
      canvas.height = img.height;
      ctx.fillStyle = "#09f";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.globalCompositeOperation = "destination-in";
      ctx.drawImage(img, 0, 0, img.width, img.height);
    };
    img.src = this.state.currentImage;
    this.setState({colourChanged:true})
    // ctx.drawImage(this, 0, 0);
  }

  // saveEditedIcon() {
  //   this.setState({colourChanged:false});
  //   var canvas = document.getElementById('wp_mapbox_gl_js_canvas');
  //   var ctx = canvas.getContext('2d');
  //   canvas.toBlob(function(blob) {
  //     var formData = new FormData();
  //     console.log(blob)
  //     formData.append("file", blob);
  //     formData.append("blob", blob);
  //     console.log(formData)
  //     this.props.dispatch(createMedia(formData,this.state.currentEditorTab));
  //   }.bind(this));
  // }

  render() {

    const popover = {
      position: 'absolute',
      zIndex: 10000,
      marginTop: '-250px'
    }

    const cover = {
      position: 'fixed',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
    }

    var markerOptions = [{
        value : 'defaults/black_default.png',
        label : 'Black Default',
        url : 'defaults/black_default.png'
    }];
    markerOptions.push({value:'custom-creator',label:'Make your own marker',url: ''})
    return (
      <div style={{width:window.innerWidth-160,height:window.innerHeight,marginLeft:-($('#wp-mapbox-gl-js-geometry-options').offset().left-160),marginTop:-($('#wp-mapbox-gl-js-geometry-options').offset().top+($(".edit-post-layout__content").length ? $(".edit-post-layout__content").scrollTop() : 0))}} className={"wp-mapbox-gl-js-custom-icon-creator now-active"}>
        <div style={{height:window.innerHeight/1.5}} className="wp-mapbox-gl-js-custom-icon-creator-container">
          <div className="wp-mapbox-gl-js-tabs-left">
            <ul>
              <li className={this.state.currentEditorTab==='defaults' ? 'wp-mapbox-gl-js-active' : ''} onClick={ () => this.setState({currentEditorTab: 'defaults'}) }>Defaults</li>
              <li className={this.state.currentEditorTab==='maki' ? 'wp-mapbox-gl-js-active' : ''} onClick={ () => this.setState({currentEditorTab: 'maki'}) }>Maki</li>
              <li className={this.state.currentEditorTab==='mapkey' ? 'wp-mapbox-gl-js-active' : ''} onClick={ () => this.setState({currentEditorTab: 'mapkey'}) }>Mapkey</li>
              <li className={this.state.currentEditorTab==='uploaded' ? 'wp-mapbox-gl-js-active' : ''} onClick={ () => this.setState({currentEditorTab: 'uploaded'}) }>Upload</li>
            </ul>
            <div className="wp-mapbox-gl-js-custom-icon-creator-editor">
              <div style={{minHeight:'100px',marginBottom:'10px'}}>
                <canvas id="wp_mapbox_gl_js_canvas"></canvas>
                <img id="wp_mapbox_gl_js_canvas_img"></img>
              </div>
              <div style={{display:'flex',padding:'0px 10px'}}>
                <strong>Size:&nbsp;&nbsp;</strong> <Slider min={0} max={200} value={this.state.iconSize} onChange={this.adjustIconSize.bind(this)} />
              </div>
              <div style={{marginTop:'10px'}}>
                <strong>Anchor:</strong><br />
                <input type="radio" name="wp_mapbox_gl_js_anchor" value="center" onChange={() => this.setState({iconAnchor:'center'})} checked={this.state.iconAnchor==='center' ? true  : false} /> Center &nbsp;&nbsp;
                <input type="radio" name="wp_mapbox_gl_js_anchor" value="bottom" onChange={() => this.setState({iconAnchor:'bottom'})} checked={this.state.iconAnchor==='bottom' ? true  : false} /> Bottom
              </div>
              <div style={{marginTop:'10px'}}>
                {/* <button onClick={this.changeColour.bind(this)} className="button">Change Colour</button>
                {this.state.colourChanged ?
                  <button onClick={this.saveEditedIcon.bind(this)} className="button">Save Edited Icon</button>
                : false }
                */}
              </div>
            </div>
          </div>
          <div className="wp-mapbox-gl-js-custom-icon-creator-icons">
            {this.state.currentEditorTab&&this.state.currentEditorTab!=='uploaded' ?
              <div className={this.state.currentEditorTab}>
                {this.state.currentEditorTab==='maki'||this.state.currentEditorTab==='mapkey' ?
                  <div style={{marginTop:'10px'}}>
                    <input type="radio" onChange={() => this.setState({currentColor:''})} checked={this.state.currentColor==='' ? true : false} value="" name="currentColor" /> <div style={{display:'inline-block',marginRight:'10px',width:'10px',height:'10px',background:'#000000'}} />
                    <input type="radio" onChange={() => this.setState({currentColor:'35a145'})} checked={this.state.currentColor==='35a145' ? true : false} value="35a145" name="currentColor" /> <div style={{display:'inline-block',marginRight:'10px',width:'10px',height:'10px',background:'#35a145'}} />
                    <input type="radio" onChange={() => this.setState({currentColor:'324ba6'})} checked={this.state.currentColor==='324ba6' ? true : false} value="324ba6" name="currentColor" /> <div style={{display:'inline-block',marginRight:'10px',width:'10px',height:'10px',background:'#324ba6'}} />
                    <input type="radio" onChange={() => this.setState({currentColor:'d62727'})} checked={this.state.currentColor==='d62727' ? true : false} value="d62727" name="currentColor" /> <div style={{display:'inline-block',marginRight:'10px',width:'10px',height:'10px',background:'#d62727'}} />
                    <input type="radio" onChange={() => this.setState({currentColor:'daed2f'})} checked={this.state.currentColor==='daed2f' ? true : false} value="daed2f" name="currentColor" /> <div style={{display:'inline-block',width:'10px',height:'10px',background:'#daed2f'}} />
                  </div>
                : false}
                <div>
                  {this.props.media[this.state.currentEditorTab].map((thisMedia, index) => {
                    return (
                      <div onClick={this.selectUploadedImage.bind(this,thisMedia)} className="wp-mapbox-gl-js-custom-icon-creator-single-icon" key={index} >
                        <img src={thisMedia.source_url} />
                      </div>
                    )
                  })}
                </div>
                {this.state.icons[this.state.currentEditorTab].map((image, index) => {
                  if(image!=='') {
                    var currentColorURL = this.state.currentColor!==''&&(this.state.currentEditorTab==='maki'||this.state.currentEditorTab==='mapkey') ? this.state.currentColor+'/'+image : image;
                    return (
                      <div onClick={this.selectImage.bind(this,currentColorURL)} className="wp-mapbox-gl-js-custom-icon-creator-single-icon" key={index} >
                        <img src={$('#wp_mapbox_gl_js_plugin_url').val()+'/wp-mapbox-gl-js/admin/wp-mapmaker/public/img/'+this.state.currentEditorTab+'/'+currentColorURL} />
                      </div>
                    )
                  } else { return false; }
                })}
              </div>
            : false}
            {this.state.currentEditorTab==='uploaded' ?
              <div className="uploaded">
                <p style={{marginTop:'15px'}}>You must have at least Wordpress 4.7 for this feature to work.</p>
                <hr />
                <input onChange={this.fileUpload.bind(this)} type="file" id="wp-mapbox-gl-js-file-upload" />
                <div>
                  {this.props.media.uploaded.map((thisMedia, index) => {
                    return (
                      <div onClick={this.selectUploadedImage.bind(this,thisMedia)} className="wp-mapbox-gl-js-custom-icon-creator-single-icon" key={index} >
                        <img src={thisMedia.source_url} />
                      </div>
                    )
                  })}
                </div>
                {/*<button className="button" onClick={this.fetchMoreMedia.bind(this)}>Fetch more media</button>*/}
              </div>
            : false}
          </div>
          <div style={{marginBottom:'70px'}} className="wp_mapbox_gl_js_actions">
            <button className="button" style={{marginRight:'10px'}} onClick={(e) => { e.preventDefault(); this.props.closeIconCreator(); }}>Close Icon Creator</button>
            <button className="button button-primary" onClick={this.setIcon.bind(this)}>Update Icon</button>
          </div>
        </div>
      </div>
    )
  }
}


// changeIconColor(e) {
//   console.log(e);
//   var canvas = document.getElementById('wp_mapbox_gl_js_canvas');
//   var ctx = canvas.getContext('2d');
//   var img  = document.getElementById('wp_mapbox_gl_js_canvas_img');
//   var imageData = ctx.getImageData(0, 0, img.width, img.height);
//
//   var colorCounting = {};
//   for (var i=0;i<imageData.data.length;i+=4) {
//     var thisColor = imageData.data[i]+','+imageData.data[i+1]+','+imageData.data[i+2];
//     if(!colorCounting[thisColor]) {
//       colorCounting[thisColor] = 1;
//     } else {
//       colorCounting[thisColor] = colorCounting[thisColor]+1;
//     }
//   }
//   console.log(colorCounting);
//   var commonestColor = [0,0]
//   for(var thisColor in colorCounting) {
//     if(colorCounting[thisColor]>commonestColor[1]) {
//       commonestColor = [thisColor,colorCounting[thisColor]]
//     }
//   }
//   console.log(commonestColor);
//   for (var i=0;i<imageData.data.length;i+=4) {
//     var thisColor = imageData.data[i]+','+imageData.data[i+1]+','+imageData.data[i+2];
//     if(commonestColor.indexOf(thisColor)>-1) {
//       imageData.data[i] = e.rgb.r;
//       imageData.data[i+1] = e.rgb.g;
//       imageData.data[i+2] = e.rgb.b;
//     }
//   }
//   // put the altered data back on the canvas
//   // ctx.drawImage(imageData, 0, 0, img.width, img.height);
//   console.log(imageData);
//   // ctx.clearRect(0, 0, canvas.width, canvas.height);
//   ctx.putImageData(imageData,0,0);
// }
// <button className="button" onClick={(e) => { e.preventDefault(); this.setState({displayIconColorPicker:!this.state.displayIconColorPicker}) }}>
//   {!this.state.displayIconColorPicker ? 'Open Color Selector' : 'Close Color Selector' }
// </button>
// { this.state.displayIconColorPicker ?
//   <div style={ popover2 }>
//     <div style={ cover } onClick={ this.handleClose }/>
//     <ChromePicker color={ this.props.currentGeometry.properties.color } onChange={this.changeIconColor.bind(this)} />
//   </div>
// : false }

export default CustomIconCreator;



// WEBPACK FOOTER //
// ./src/components/CustomIconCreator.js